import shops from "../images/icons/products/shops.svg"
import design from "../images/icons/products/design.svg"
import neuromarketing from "../images/icons/products/neuromarketing.svg"
import apps from "../images/icons/products/aplikacje.svg"
import www from "../images/icons/products/www.svg"
import badania from "../images/icons/products/badania.svg"

export const offer = [
  {
    icon: shops,
    title: "Sklepy internetowe",
    description: `Spersonalizowany i szybki sklep internetowy, który poszerza Twoje granice
        w e-commerce.`,
    list: [
      "Duże sklepy internetowe",
      "Optymalizacja koszyka",
      "Małe, lokalne sklepy",
      "Audyt sklepu",
    ],
  },
  {
    icon: neuromarketing,
    title: "Marketing",
    description: `Wprowadzamy na rynek z sukcesem nowe produkty, stosując najskuteczniejsze środki marketingowe.`,
    list: [
      "Prowadzenie social media",
      "Kampanie reklamowe",
      "Materiały reklamowe",
      "Branding firmy",
    ],
  },
  {
    icon: design,
    title: "UI/UX Design",
    description: `Rozwiązania w oparciu o badania na użytkownikach, na nich opieramy interfejs stron, sklepów i aplikacji.`,
    list: [
      "Badania na użytkownikach",
      "Optymalizacja userflow",
      "Uproszczanie interfejsu",
      "Testowanie produktu",
    ],
  },
  {
    icon: www,
    title: "Strony www",
    description: `W pełni responsywna i  zoptymalizowana strona internetowa, przynosząca zysk Twojemu biznesowi.`,
    list: ["Strona CMS", "Strona wizytówka", "Strona produktu", "Strona firmy"],
  },
  {
    icon: badania,
    title: "Badania rynku",
    description: ` Zgromadzimy wszystkie potrzebne informacje o Twoim potencjalnym / obecnym kliencie.`,
    list: [
      "Ustalenie grupy docelowej",
      "Analiza przedsiębiorstwa",
      "Badanie mocy reklamy",
      "Potencjalni klienci",
    ],
  },
  {
    icon: apps,
    title: "Aplikacje internetowe",
    description: `CMS, portal internetowy, forum, blog. Aplikacja dla Ciebie, która zapewni Tobie pasywny zysk.`,
    list: [
      "Forum internetowe",
      "Portal internetowy",
      "Aplikacja webowa",
      "CMS/Blog",
    ],
  },
]
